import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/tailwind.css";
// primeicons, for the header's cog/menu glyphs (Anvil pulls in the same package).
import "primeicons/primeicons.css";
// The HTML host only carries <body id="reactroot"> — everything else lives in React/TypeScript.
const container = document.getElementById("reactroot");
if (container) {
    createRoot(container).render(_jsx(App, {}));
}
